import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { SimulationCountsRequestAction } from '~src/simulation/actions/SimulationCountsRequestAction';
import { clearSpaceContentCountsAction, contentCountsRequest } from '~src/spacesPlatform/actions/ContentCountsActions';

export function* handleSimulationCountsRequest(action: SimulationCountsRequestAction): SagaIterator {
  yield put(clearSpaceContentCountsAction(action.spaceType));
  yield put(contentCountsRequest());
}
